import React, { useRef, useState } from 'react';
import { Star } from 'lucide-react';
import apiClient from '../utils/apiClient';

interface Props {
  songId: number;
  title: string;
  rating: number | null;
  onSaved: (rating: number | null) => void;
}

export default function CollectionRating({ songId, title, rating, onSaved }: Props) {
  const saving = useRef(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');
  const save = async (value: number | null) => {
    if (saving.current) return;
    saving.current = true; setBusy(true); setError(''); setMessage('');
    try {
      const response = await apiClient.put(`/songs/collections/${songId}/rating`, { rating: value });
      onSaved(response.data.rating);
      setMessage(value === null ? 'Rating cleared.' : `Saved ${value}/10.`);
    } catch {
      setError('Could not save your rating. Please try again.');
    } finally { saving.current = false; setBusy(false); }
  };
  return <div className="collection-rating">
    <fieldset disabled={busy}>
      <legend>Your rating <span>{rating === null ? 'Not rated' : `${rating}/10`}</span></legend>
      <div className="collection-rating__stars">
        {Array.from({ length: 10 }, (_, index) => index + 1).map(value => <label key={value} title={`${value} out of 10`}>
          <input className="visually-hidden" type="radio" name={`rating-${songId}`} value={value}
            checked={rating === value} onChange={() => void save(value)} aria-label={`${title}: ${value} out of 10 stars`} />
          <Star size={22} aria-hidden="true" className={rating !== null && value <= rating ? 'is-filled' : ''} />
        </label>)}
      </div>
    </fieldset>
    <div className="collection-rating__status">
      <span role="status">{busy ? 'Saving…' : message}</span>
      {rating !== null && <button type="button" className="btn btn-link btn-sm" disabled={busy} onClick={() => void save(null)}>Clear rating</button>}
    </div>
    {error && <p role="alert" className="text-danger small">{error}</p>}
  </div>;
}
